import React from 'react'
import { Route, Switch, useRouteMatch } from 'react-router-dom'
import VendorListing from 'views/admin/vendors/VendorListing'
import VendorForm from 'views/admin/vendors/VendorForm'

const Vendors = () => {
  const { path } = useRouteMatch()
  return (
    <Switch>
      <Route exact path={path}>
        <VendorListing />
      </Route>
      <Route path={`${path}/new`}>
        <VendorForm />
      </Route>
      <Route path={`${path}/edit/:vendorId`}>
        <VendorForm />
      </Route>
    </Switch>
  )
}

export default Vendors
